(() => {
  if (customElements.get('cyber-month-deal-tooltip')) return;
  let activeTooltip;
  let nextId = 0;

  customElements.define('cyber-month-deal-tooltip', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.cyber-month-badge__pill');
      this.tooltip = this.querySelector('.kiyoko-ingredient-tooltip');
      if (!this.button || !this.tooltip) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.nativePopover = typeof this.tooltip.showPopover === 'function';
      if (this.nativePopover) this.tooltip.setAttribute('popover', 'manual');
      this.tooltip.id = `cyber-month-tooltip-${++nextId}`;
      this.button.setAttribute('aria-controls', this.tooltip.id);
      this.button.setAttribute('aria-expanded', 'false');
      this.tooltip.classList.add('cyber-month-floating');
      const hover = () => window.matchMedia('(hover: hover) and (min-width: 750px)').matches;
      this.addEventListener('pointerenter', () => { if (hover()) this.open(); }, options);
      const leave = () => {
        clearTimeout(this.closeTimer);
        this.closeTimer = setTimeout(() => {
          if (!this.matches(':hover') && !this.tooltip.matches(':hover')) this.close();
        }, 120);
      };
      this.addEventListener('pointerleave', () => { if (hover()) leave(); }, options);
      this.tooltip.addEventListener('pointerleave', () => { if (hover()) leave(); }, options);
      this.button.addEventListener('click', (event) => {
        event.stopPropagation();
        if (this.isOpen) this.close();
        else this.open();
      }, options);
      this.button.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown') { event.preventDefault(); this.open(); }
      }, options);
      this.tooltip.addEventListener('click', (event) => {
        event.stopPropagation();
        if (event.target.closest('.kiyoko-ingredient-tooltip__close')) {
          this.close();
          this.button.focus();
        }
      }, options);
      document.addEventListener('pointerdown', (event) => {
        if (!this.contains(event.target) && !this.tooltip.contains(event.target)) this.close();
      }, options);
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.isOpen) { this.close(); this.button.focus(); }
      }, options);
      window.addEventListener('resize', () => this.close(), options);
      window.addEventListener('scroll', (event) => {
        if (!this.tooltip.contains(event.target)) this.close();
      }, { ...options, capture: true });
    }

    open() {
      if (this.isOpen) return;
      if (activeTooltip && activeTooltip !== this) activeTooltip.close();
      activeTooltip = this;
      this.isOpen = true;
      this.button.setAttribute('aria-expanded', 'true');
      this.tooltip.classList.add('is-open');
      // The top layer escapes overflow and transformed carousel ancestors.
      if (this.nativePopover) this.tooltip.showPopover();
      else document.body.append(this.tooltip);
      const anchor = this.button.getBoundingClientRect();
      const rect = this.tooltip.getBoundingClientRect();
      const viewportWidth = document.documentElement.clientWidth;
      const viewportHeight = window.innerHeight;
      const left = Math.max(12, Math.min(anchor.left + anchor.width / 2 - rect.width / 2, viewportWidth - rect.width - 12));
      const above = anchor.top >= rect.height + 22;
      const top = above ? anchor.top - rect.height - 10 : Math.min(anchor.bottom + 10, viewportHeight - rect.height - 12);
      this.tooltip.style.setProperty('--cyber-tooltip-height', `${rect.height}px`);
      this.tooltip.style.setProperty('--cyber-tooltip-left', `${left}px`);
      this.tooltip.style.setProperty('--cyber-tooltip-top', `${Math.max(12, top)}px`);
      this.tooltip.style.setProperty('--cyber-tooltip-arrow', `${Math.max(16, Math.min(anchor.left + anchor.width / 2 - left, rect.width - 16))}px`);
      this.tooltip.dataset.placement = above ? 'above' : 'below';
    }

    close() {
      if (!this.isOpen) return;
      this.isOpen = false;
      if (activeTooltip === this) activeTooltip = null;
      this.button.setAttribute('aria-expanded', 'false');
      if (this.nativePopover && this.tooltip.matches(':popover-open')) this.tooltip.hidePopover();
      this.tooltip.classList.remove('is-open');
      if (!this.nativePopover && this.isConnected) this.append(this.tooltip);
    }

    disconnectedCallback() {
      this.close();
      clearTimeout(this.closeTimer);
      if (this.controller) this.controller.abort();
      if (!this.nativePopover && this.tooltip) this.tooltip.remove();
    }
  });
})();
